import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "../features/auth/store/login/reducer";
import OrganizationReducer from "../features/organization/store/reducer";
import SurveyReducer from "../features/survey/store/reducer";

export const rootReducer = combineReducers({
  auth: AuthReducer,
  organization: OrganizationReducer,
  survey: SurveyReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
